import BaseApiManager from '../baseApiManager';
import { store } from '../../../redux/store';
import { showError } from '../../../redux/reducers/alerts/actions';

export default class CategoryApi extends BaseApiManager {
  static async getInstance() {
    if (!CategoryApi.instance) {
      CategoryApi.instance = new CategoryApi();
      CategoryApi._initPromise = CategoryApi.instance.init();
    }
    await CategoryApi._initPromise;
    return CategoryApi.instance;
  }

  async fetchCategories(groupId, attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/group/${groupId}/categories`);

      if (this.isSuccess(res.status)) {
        return res.data.categories;
      } else {
        store.dispatch(showError(true, `Server error when try to get categories. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchCategories.bind(this), error, attempt, groupId);
    }
  }

  async renameCategory(title, id, attempt = 0) {
    try {
      const res = await this.patch(`user/${this.userId}/category/${id}`, { title });

      if (!this.isSuccess(res.status)) {
        store.dispatch(showError(true, `Server error when try to rename category. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.renameCategory.bind(this), error, attempt, title, id);
    }
  }

  async fetchItems(id, attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/category/${id}/images`);

      if (this.isSuccess(res.status)) {
        return res.data.images;
      } else {
        store.dispatch(showError(true, `Server error when try to get category images. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchItems.bind(this), error, attempt, id);
    }
  }

  async addCategory(title, groupId, attempt = 0) {
    try {
      const res = await this.post(`user/${this.userId}/group/${groupId}/categories`, { title, readonly: false });

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when try to add category. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.addCategory.bind(this), error, attempt, title, groupId);
    }
  }

  async addImage(imgData, categoryId, templateId, attempt = 0) {
    try {
      const res = await this.put(
        `user/${this.userId}/category/${categoryId}/template/${templateId}/image`,
        imgData,
        {
          'Content-Type': 'image/png',
        },
      );

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when try to add image. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(
        this.addImage.bind(this), error, attempt, imgData, categoryId, templateId,
      );
    }
  }

  async deleteCategory(id, attempt = 0) {
    try {
      const res = await this.delete(`user/${this.userId}/category/${id}`);

      if (this.isSuccess(res.status)) {
        return true;
      } else {
        store.dispatch(showError(true, `Server error when try to delete category. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.deleteCategory.bind(this), error, attempt, id);
    }
  }
}
